// extracted by mini-css-extract-plugin
export var desktopLayout = "G_cl";
export var mobileLayout = "G_cm";
export var ribbonContainer = "G_ck";